/* eslint-disable */
/**
 * NOTE: THIS IS AN AUTO-GENERATED FILE. DO NOT MODIFY IT DIRECTLY.
 */
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
export const SummaryFragmentDoc = gql `
    fragment Summary on Transfer {
        transactionHash
        to
        block
        timestamp
        from
        txFee
        status
    }
`;
export const BlockTransactionFragmentDoc = gql `
    fragment BlockTransaction on EthTransfer {
        transfer {
            ...Summary
        }
        value
    }
    ${SummaryFragmentDoc}
`;
export const BlockTransactionsFragmentDoc = gql `
    fragment BlockTransactions on ETHTransfers {
        transfers {
            ...BlockTransaction
        }
    }
    ${BlockTransactionFragmentDoc}
`;
export const TransferFragmentDoc = gql `
    fragment Transfer on ETHTransactionTransfer {
        transfer {
            ...Summary
        }
        value
    }
    ${SummaryFragmentDoc}
`;
export const EthTransfersFragmentDoc = gql `
    fragment EthTransfers on ETHTransactionTransfers {
        transfers {
            ...Transfer
        }
        nextKey
    }
    ${TransferFragmentDoc}
`;
export const GetBlockTransfersDocument = gql `
    query getBlockTransfers($_number: Int) {
        getBlockTransfers(number: $_number) {
            ...BlockTransactions
        }
    }
    ${BlockTransactionsFragmentDoc}
`;
/**
 * __useGetBlockTransfersQuery__
 *
 * To run a query within a Vue component, call `useGetBlockTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockTransfersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBlockTransfersQuery({
 *   _number: // value for '_number'
 * });
 */
export function useGetBlockTransfersQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(GetBlockTransfersDocument, variables, options);
}
export function useGetBlockTransfersLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(GetBlockTransfersDocument, variables, options);
}
export const GetAllTxsDocument = gql `
    query getAllTxs($_limit: Int, $_nextKey: String) {
        getEthTransactionTransfers(limit: $_limit, nextKey: $_nextKey) {
            ...EthTransfers
        }
    }
    ${EthTransfersFragmentDoc}
`;
/**
 * __useGetAllTxsQuery__
 *
 * To run a query within a Vue component, call `useGetAllTxsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTxsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTxsQuery({
 *   _limit: // value for '_limit'
 *   _nextKey: // value for '_nextKey'
 * });
 */
export function useGetAllTxsQuery(variables = {}, options = {}) {
    return VueApolloComposable.useQuery(GetAllTxsDocument, variables, options);
}
export function useGetAllTxsLazyQuery(variables = {}, options = {}) {
    return VueApolloComposable.useLazyQuery(GetAllTxsDocument, variables, options);
}
export const NewTransfersCompleteFeedDocument = gql `
    subscription newTransfersCompleteFeed {
        newTransfersCompleteFeed {
            block
            type
        }
    }
`;
/**
 * __useNewTransfersCompleteFeedSubscription__
 *
 * To run a query within a Vue component, call `useNewTransfersCompleteFeedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewTransfersCompleteFeedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useNewTransfersCompleteFeedSubscription();
 */
export function useNewTransfersCompleteFeedSubscription(options = {}) {
    return VueApolloComposable.useSubscription(NewTransfersCompleteFeedDocument, {}, options);
}
